import React, { useEffect } from 'react'
import { Cursor } from 'react-creative-cursor'
import './CustomCursor.scss'

const CustomCursor = () => {
    useEffect(() => {
        // const body = document.querySelector('body')
        // body.dataset.cursorExclusion = true
        const cursor = document.querySelector('.c-cursor')

        const anchorTags = document.querySelectorAll('a, button')

        anchorTags.forEach(el => {
            el.addEventListener('mouseover', () => {
                cursor.style.width = '80px'
                cursor.style.height = '80px'
            })
            el.addEventListener('mouseout', () => {
                cursor.style.width = '20px'
                cursor.style.height = '20px'
            })
        })
    }, [])

    return (
        <Cursor
            isGelly={true}
            cursorBackgrounColor={'#fff'}
            animationDuration={0.8}
            cursorSize={20}
            exclusionBackgroundColor={'#fff'}
        />
    )
}

export default CustomCursor
